export enum BackendService {
	Auth = import.meta.env.VITE_AUTH_API,
	Realtime = import.meta.env.VITE_REALTIME_API,
	Notifications = import.meta.env.VITE_NOTIFICATIONS_API,
}
